export default {
  setProperty(state, { payload, property }) {
    state[property] = payload;
  },

  setLoyaltyItems(state, payload) {
    state.items.items = payload.data;
    state.items.pagination = payload.pagination;
  },

  setLoyaltyCustomer(state, payload) {
    state.customers.customers = payload.data;
    state.customers.pagination = payload.pagination;
  },
};
